'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var io = require('orbit-db-io');

var AccessControllerManifest = /*#__PURE__*/function () {
  function AccessControllerManifest(type) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AccessControllerManifest);

    this.type = type;
    this.params = params;
  }

  _createClass(AccessControllerManifest, null, [{
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfs, manifestHash) {
        var options,
            _yield$io$read,
            type,
            params,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

                if (!options.skipManifest) {
                  _context.next = 7;
                  break;
                }

                if (options.type) {
                  _context.next = 4;
                  break;
                }

                throw new Error('No manifest, access-controller type required');

              case 4:
                return _context.abrupt("return", new AccessControllerManifest(options.type, {
                  address: manifestHash
                }));

              case 7:
                // TODO: ensure this is a valid multihash
                if (manifestHash.indexOf('/ipfs') === 0) {
                  manifestHash = manifestHash.split('/')[2];
                }

                _context.next = 10;
                return io.read(ipfs, manifestHash);

              case 10:
                _yield$io$read = _context.sent;
                type = _yield$io$read.type;
                params = _yield$io$read.params;
                return _context.abrupt("return", new AccessControllerManifest(type, params));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function resolve(_x, _x2) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ipfs, type, params) {
        var manifest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!params.skipManifest) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", params.address);

              case 2:
                manifest = {
                  type: type,
                  params: params
                };
                return _context2.abrupt("return", io.write(ipfs, 'dag-cbor', manifest));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function create(_x3, _x4, _x5) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return AccessControllerManifest;
}();

module.exports = AccessControllerManifest;